/**
 * Sends a conversion event to Google Ads using gtag
 * @param conversionId - The Google Ads conversion ID
 * @param conversionLabel - The conversion label for the specific action
 * @param gclid - The Google Click ID (optional, will be passed if available)
 * @param value - The conversion value (optional)
 * @returns void
 */
export const sendGoogleAdsConversion = (
  conversionId: string,
  conversionLabel: string,
  gclid?: string,
  value?: number,
): void => {
  // Build the conversion event parameters
  const conversionData: Record<string, any> = {
    send_to: `${conversionId}/${conversionLabel}`,
  }

  // Add optional parameters if provided
  if (gclid) {
    conversionData.gclid = gclid
  }

  if (value !== undefined) {
    conversionData.value = value
    conversionData.currency = 'USD'
  }

  // Send the conversion event
  window.gtag('event', 'conversion', conversionData)
}
